import { Editor, Path } from 'slate';
import type { EditorPlugin } from '../../types/aha-editor';
import ToolInsertDividerLine from './tools/ToolInsertDividerLine';
import Markdown from '../Markdown/Markdown';
import { isDividerLineElement } from '../../types/guards';
import NodeUtils from '../../AhaEditorUtils/NodeUtils';

const revertDividerLine = (editor: Editor): void => {
  const { selection } = editor;
  if (!selection) return;

  const parentPath = Path.parent(selection.anchor.path);
  if (!parentPath) return;
  const dividerLineEntry = NodeUtils.previousSibling(editor, parentPath, {
    match: isDividerLineElement,
  });

  if (dividerLineEntry) {
    Editor.deleteBackward(editor);
  }
};

const insertDividerLine = (editor: Editor): void => {
  ToolInsertDividerLine.action({ editor });
};

const DividerLineMarkdownPlugin: EditorPlugin = {
  name: 'Divider line Markdown plugin',
  dependencies: [Markdown],
  markdown: [
    {
      type: 'block',
      shortcuts: ['--'],
      triggerCharacters: ['-'],
      convert: insertDividerLine,
      revert: revertDividerLine,
      shiftTabRevert: false,
      ignoreUncaptured: false,
      ignoreSameCharacterString: false,
    },
  ],
};
export default DividerLineMarkdownPlugin;
